<template>
    <component :is="componentIsA" v-bind="props" @click="triggerGA">
        <slot></slot>
    </component>
</template>

<script>
    export default {

        props: ['componentIsA', 'props'],

        methods: {
            triggerGA(element) {
                let el = element.currentTarget;

                ga('send', {
                    hitType: 'event',
                    eventCategory: el.getAttribute('ga-category'),
                    eventAction: 'Click',
                    eventLabel: el.getAttribute('ga-label'),
                });

                this.$emit('componentClicked')
            }
        },
    }
</script>
